import * as React from "react";
import { SearchInputWrap, SearchInputField, SearchLoadingIcon, SearchClearIcon, SearchIcon } from "../SearchBox/searchbox.elements";
export default function UserSearchInput(a) {
  var b = a.query,
      c = a.onChange,
      d = a.onToggleSearchResults,
      e = a.onKeyDown,
      f = a.onClear,
      g = a.loading,
      h = React.useRef(null),
      i = React.useRef(),
      _React$useState = React.useState(!1),
      j = _React$useState[0],
      k = _React$useState[1];

  return React.useEffect(function () {
    return function () {
      window.clearTimeout(i.current);
    };
  }, []), React.useEffect(function () {
    j && 0 < b.length ? d(!0) : d(!1);
  }, [j, b]), /*#__PURE__*/React.createElement(SearchInputWrap, null, /*#__PURE__*/React.createElement(SearchInputField, {
    type: "text",
    autoComplete: "off",
    value: b || "",
    onChange: c,
    id: "search",
    ref: h,
    placeholder: "Search the docs",
    onFocus: function onFocus() {
      return k(!0);
    },
    onBlur: function onBlur() {
      return i.current = window.setTimeout(function () {
        return k(!1);
      }, 200);
    },
    onKeyDown: e
  }), j ? g ? /*#__PURE__*/React.createElement(SearchLoadingIcon, null) : /*#__PURE__*/React.createElement(SearchClearIcon, {
    onClick: f
  }) : /*#__PURE__*/React.createElement(SearchIcon, {
    onClick: function onClick() {
      return h.current && h.current.focus();
    }
  }));
}